import React from 'react';
import {List, Datagrid, TextField, Filter, TextInput, DateInput} from 'react-admin';

const AdminFilter = (props) => (
  <Filter {...props}>
    {/* <TextInput label="Search" source="q" alwaysOn /> */}
    <DateInput source="startDate" alwaysOn />
    <DateInput source="endDate" alwaysOn />
    <TextInput source="jobId" label="Job ID" alwaysOn />
    <TextInput source="vendorId" label="Vendor ID" alwaysOn />
    <TextInput source="customerId" label="Customer ID" alwaysOn />
    <TextInput source="modeOfPayment" label="Mode Of Payment" alwaysOn />
    <TextInput source="bankTransactionId" label="Bank Transaction ID" alwaysOn />
    <TextInput source="commissionPercentage" label="Commission Percentage" alwaysOn />
    <TextInput source="commissionPaymentStatus" label="Commission Payment Status" alwaysOn />
    <TextInput source="serviceCategory" label="Service Category" alwaysOn />
    <TextInput source="paymentStatus" label="Payment Status" alwaysOn />
    <TextInput source="amountReceived" label="Total Service amount" alwaysOn />
    <TextInput source="commissionAmount" label="Commission Amount" alwaysOn />
    <TextInput source="vendorEarning" label="Vendor Chargeable amount" alwaysOn />
  </Filter>
);

const rowClick = () => {
  // if (record.id === 0) {
  //   return 'show';
  // }
  // return 'edit';
  return 'show';
};

// const ShowEditButton = ({record, basePath}) => {
//   return record.id !== 0 && <EditButton basePath={basePath} record={record} />;
// };

// const ShowEditButton = ({record, basePath}) => {
//   return record.id !== 0 && <EditButton basePath={basePath} record={record} />;
// };

export const AccountList = (props) => (
  <List title=" Accounts" {...props} filters={<AdminFilter />}>
    <Datagrid rowClick={rowClick} /*expand={<AdminEdit/> }*/>
      {/*<TextField source="id" />*/}
      <TextField source="jobId" label="Job ID" />
      <TextField source="vendorId" label="Vendor ID" />
      <TextField source="customerId" label="Customer ID" />

      <TextField source="modeOfPayment" label="Payment Mode" />
      <TextField source="bankTransactionId" label="Bank Transaction ID" />
      <TextField source="internalTransactionId" label="Internal Transaction ID" />

      <TextField source="amountReceived" label="Total Service amount" />
      <TextField source="commissionAmount" label="Commission Amount" />
      <TextField source="vendorEarning" label="Vendor Chargeable amount" />

      <TextField source="commissionPercentage" label="Commission Percentage" />
      <TextField source="commissionPaymentStatus" label="Commission Payment Status" />
      <TextField source="commissionTransactionID" label="Commission Transaction ID" />

      <TextField source="date" label="date" />
      <TextField source="serviceCategory" label="Service Category" />
      <TextField source="paymentStatus" label="Payment Status" />

      <TextField source="transactionId" label="Transaction ID" />
      <TextField source="mihPayId" label="mih Pay ID" />
    </Datagrid>
  </List>
);
export default AccountList;
